import React, { useState } from "react"
import {
   Container,
   Row,
   Col,
   TabContent,
   TabPane,
   Nav,
   NavItem,
} from "reactstrap"
import "./style.scss"

const TabRouting = ({
   tabItems = [
      {
         title: "",
         identifier: "1",
         className: "",
         activeIcon: "",
         icon: "",
         content: <div> </div>,
      },
   ],
}) => {
   const [activeTab, setActiveTab] = useState(tabItems[0].identifier)

   const toggle = tab => {
      if (activeTab !== tab) {
         setActiveTab(tab)
      }
   }

   return (
      <div className="casita-container-wrapper">
         <Container fluid>
            <Row>
               <Col className="col-12">
                  <div className="admin-location mb-4">
                     <div className="al-navtabs-main toptabs-main">
                        <Nav tabs className="al-nav-tabs">
                           {tabItems.map(el => (
                              <NavItem
                                 key={el.identifier}
                                 className={`${el.className} al-nav-item d-flex`}
                              >
                                 <div
                                    className={
                                       activeTab === el.identifier
                                          ? "bg-navitems-primary"
                                          : "bg-navitems-secondary"
                                    }
                                 >
                                    <a
                                       className="ps-1 d-inline-block al-nav-link mx-3 d-flex justify-content-center align-items-center"
                                       onClick={() => toggle(el.identifier)}
                                    >
                                       <div>{el.title}</div>
                                    </a>
                                 </div>
                              </NavItem>
                           ))}
                        </Nav>
                     </div>
                  </div>
                  <div>
                     <TabContent activeTab={activeTab}>
                        {tabItems.map(el => (
                           <TabPane tabId={el.identifier} key={el.identifier}>
                              <Row>
                                 <Col sm="12" className="production-line-tab">
                                    {activeTab === el.identifier && el.content}
                                 </Col>
                              </Row>
                           </TabPane>
                        ))}
                     </TabContent>
                  </div>
               </Col>
            </Row>
         </Container>
      </div>
   )
}

export default TabRouting
